export default {
  clientNumber: 'מספר תיק',
  company: 'חברה מנהלת',
  hp: 'מספר מזהה',
  clientName: 'שם לקוח',
  branch: 'מוצר',
  edit: 'ערוך תיק',
  agentCommission: 'עמלת סוכן %',
  accordType: 'עמלה',
  addClient: 'הוסף תיק',
  comments: 'הערות',
  title: 'צפייה בתיקים של הסוכן {1}',
  headers: {
    clients: 'תיקים',
  },
};
